import { render } from "./accountInfo.vue?vue&type=template&id=912f97ee&scoped=true"
import script from "./accountInfo.vue?vue&type=script&lang=js"
export * from "./accountInfo.vue?vue&type=script&lang=js"

import "./accountInfo.vue?vue&type=style&index=0&id=912f97ee&scoped=true&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-912f97ee"]])

export default __exports__